import { PatientTableDataFragment } from '../../generated/graphql';

export const isPatientNewFromStorefront = (patient: PatientTableDataFragment) =>
  patient.fromStorefront && !patient.lastSeenAt;
